export default __webpack_public_path__ + "static/media/11.559b2ea1.mp3";